import { z } from "zod";

const CreateAgentSchema = z.object({
    name: z.string().min(1, "Name is required"),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, "Invalid color code. Use format #RRGGBB"),
    website: z.string().url().or(z.literal("")).optional(),
    email: z.string().email().or(z.literal("")).optional(),
    phone: z.string().min(1, "Phone number is required").or(z.literal("")).optional(),
    is_active: z.union([z.string(), z.boolean()]).optional(),
});

export { CreateAgentSchema };
export type CreateAgentFormData = z.infer<typeof CreateAgentSchema>;
